export default {
    imgUrl: '/imgs/',
    appId: 'wxe6d64706308fd8b3',
    // RSA加密key
    RES_PUBLIC_KEY: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCEJmRI+uoYPojWNJofzfSQxFH18MbXiHQtXXrFrDLuX2v8aJSac1XIr8jBicC/RzbUpeZEMXALlSrZF7Q6b9iqbAB+W8BXA+93GEnZLcPff3svmFDLktfAsLsPrDyvRjJF9O7sJ7hP+8RHtT+f8Gdj+5GWsK8hikBafH7oSpyTIwIDAQAB',
    //测试-get
    topics: 'https://cnodejs.org/api/v1/topics',
    //微信h5登录1
    wechat: 'https://open.weixin.qq.com/connect/qrconnect',
    //微信h5登录2
    wechat2: 'https://open.weixin.qq.com/sns/explorer_broker',
    //微信公众号内登录(获取code)
    wechat_auth: 'https://open.weixin.qq.com/connect/oauth2/authorize',
    //登录(获取openId)
    access_token: 'https://api.weixin.qq.com/sns/oauth2/access_token',
    //渠道是否有效
    isChannelValid: 'mall/h5/channel/v100/isChannelValid',
    //产品中心顶部banner
    queryBannerByChannelId: 'mall/h5/banner/v100/queryBannerByChannelId',
    // 商品分类--post
    queryGoodClassList: 'mall/h5/goods/v100/queryGoodClassList',
    //分类商品列表--post
    queryGoodsList: 'mall/h5/goods/v100/queryGoodsList',
    //商品详情--post
    goodsDetail: 'mall/h5/goods/v100/goodsDetail',
    //商品推荐
    recommendGoods: 'mall/h5/goods/v100/recommendGoods',
    //登录
    login: 'mall/h5/login/v100/login',
    //登录是否过期
    verifyUser: 'mall/h5/login/v100/verifyUser',
    //微信登录H5
    weChatLogin: 'mall/h5/login/v100/weChatLogin',
    //微信登录公众号授权登录
    weChatOpenAccountLogin: 'mall/h5/login/v100/weChatOpenAccountLogin',
    //微信登录公众号静默登录
    queryWeChatOpenId: 'mall/h5/login/v100/queryWeChatOpenId',
    //绑定手机号
    bindPhone:'mall/h5/login/v100/bindPhone',
    //验证码
    sendCode: 'mall/h5/login/v100/sendCode',
    //地址list
    queryAddressList: 'mall/h5/address/v100/queryAddressList',
    //添加地址
    addOrEditAddress: 'mall/h5/address/v100/addOrEditAddress',
    //删除地址
    deleteAddress: 'mall/h5/address/v100/deleteAddress',
    // 设置默认地址
    setDefaultAddress: 'mall/h5/address/v100/setDefaultAddress',
    // 提交订单
    //submitOrder: 'mall/h5/order/v100/submitOrder',
    // 提交订单
    submitOrder: 'mall/h5/order/v101/submitOrder',
    //统一下单
    orderPay: 'mall/h5/order/v100/orderPay',
    // 支付宝统一下单
    orderAliPay: 'mall/h5/order/v100/orderAliPay',
    //支付回调
    payCallBack: 'mall/h5/order/v100/payCallBack',
    //订单列表
    queryOrderList: 'mall/h5/myorder/v100/queryOrderList',
    //退款订单列表
    queryMyRefundList: 'mall/h5/myorder/v100/queryMyRefundList',
    //订单详情
    queryOrderInfo: 'mall/h5/myorder/v100/queryOrderInfo',
    // 查询订单信息
    findOrderMsg: 'mall/h5/order/v100/findOrderMsg',
    //物流
    queryLogisticsList:'mall/h5/logistics/v100/queryLogisticsList',
    //订单商品信息
    orderGoodsMsg: 'mall/h5/order/v100/orderGoodsMsg',
    //取消订单
    cancelOrder: 'mall/h5/myorder/v100/cancelOrder',
    //取消退款申请
    cancelRefund: 'mall/h5/myorder/v100/cancelRefund',
    //提交退款申请
    commitRefund: 'mall/h5/myorder/v100/commitRefund',
    //确认收货
    confirmReceipt: 'mall/h5/myorder/v100/confirmReceipt',
    //确认回寄
    confirmReturn: 'mall/h5/myorder/v100/confirmReturn',
    //删除订单
    deleteOrder: 'mall/h5/myorder/v100/deleteOrder',
    // 修改订单地址
    updateOrderAddress: 'mall/h5/order/v100/updateOrderAddress',
    // 获取申请退款订单详情
    getApplyRefundInfo: 'mall/h5/myorder/v100/getApplyRefundInfo',
    //查询退款详情
    queryRefundInfo: 'mall/h5/myorder/v100/queryRefundInfo',
    //报告列表
    queryList: 'mall/h5/report/v100/queryListNew',
    // 报告详情
    detail:'mall/h5/report/v100/detailNew',
    //上传图片
    imageUpload: 'pc/upload/uploadImage',
    // 发票
    addInvoice: 'mall/h5/invioce/v100/addInvoice',
	// 活动设置
	querySet: 'mall/h5/set/v100/querySet',
	querySet: 'mall/h5/set/v100/querySet',
	//渠道选择
	queryChannelList:'mall/h5/channel/v100/queryChannelList',
	//查询渠道售卖商品
	queryGoodsByChannelId:'mall/h5/channel/v100/queryGoodsByChannelId',
	//提交免费订单
	submitFreeOrder:'mall/h5/order/v101/submitFreeOrder',
	//提交免费订单账户密码接口
	specialLoggin:'mall/h5/login/v100/specialLoggin',
	//扫一扫
	jsapisign:'mall/h5/nucleic/v101/jsApiSignTwo',
	//提交免费订单条形码有效性
	barCodeJudge:'mall/h5/order/v101/barCodeJudge',
	//用户评价
	saveUserEvaluate:'mall/h5/report/v100/saveUserEvaluate'
	
	
}